import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { errMsg, useApi } from "../../lib/api";

export const ChatPanel = ({ spaceId, messages, setMessages, meId }) => {
  const api = useApi();
  const [text, setText] = useState("");
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [messages.length]);
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const { data } = await api.post(`/spaces/${spaceId}/chat`, { text });
      setMessages((m) => (m.some((x) => x.id === data.id) ? m : [...m, data]));
      setText("");
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="flex h-[440px] flex-col" data-testid="chat-panel">
      <div className="flex-1 overflow-y-auto space-y-3 pr-1">
        {messages.length === 0 && <p className="text-sm text-zinc-500" data-testid="chat-empty">No messages yet. Say hi.</p>}
        {messages.map((m) => (
          <div key={m.id} className="text-sm" data-testid={`chat-message-${m.id}`}>
            <span className={`font-semibold ${m.user_id === meId ? "text-yellow-300" : m.role === "student" ? "text-zinc-200" : "text-pink-300"}`}>{m.name}</span>
            <span className="ml-2 mono text-[10px] text-zinc-600">{new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
            <p className="text-zinc-300 break-words">{m.text}</p>
          </div>
        ))}
        <div ref={end} />
      </div>
      <form onSubmit={send} className="mt-3 flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} maxLength={500} placeholder="Message the room"
          data-testid="chat-input" className="flex-1 rounded-[3px] bg-black border border-zinc-800 px-3 py-2 text-sm outline-none focus:border-yellow-400" />
        <button type="submit" data-testid="chat-send-btn" className="rounded-[3px] bg-yellow-400 px-3 text-black hover:bg-yellow-300 transition-colors"><Send className="h-4 w-4" /></button>
      </form>
    </div>
  );
};
